class TkGiftGuide extends HTMLElement {
  connectedCallback() {
    this.links = Array.from(this.querySelectorAll('.tk-gift-guide__link'));
    this.imageWrappers = Array.from(this.querySelectorAll('.tk-gift-guide__image-wrapper'));
    this.ctas = Array.from(this.querySelectorAll('.tk-gift-guide__cta'));

    if (this.links.length === 0) return;

    this.hoverQuery = window.matchMedia('(hover: hover)');
    this.onHoverChange = this.onHoverChange.bind(this);
    this.hoverQuery.addEventListener('change', this.onHoverChange);

    this.onMouseEnter = (e) => this.setActiveFromEvent(e);
    this.onFocusIn = (e) => this.setActiveFromEvent(e);

    if (this.hoverQuery.matches) this.bindHover();
  }

  disconnectedCallback() {
    if (this.hoverQuery) this.hoverQuery.removeEventListener('change', this.onHoverChange);
    this.unbindHover();
  }

  bindHover() {
    this.links.forEach((link) => {
      link.addEventListener('mouseenter', this.onMouseEnter);
      link.addEventListener('focusin', this.onFocusIn);
    });
  }

  unbindHover() {
    this.links.forEach((link) => {
      link.removeEventListener('mouseenter', this.onMouseEnter);
      link.removeEventListener('focusin', this.onFocusIn);
    });
  }

  onHoverChange() {
    this.unbindHover();
    if (this.hoverQuery.matches) this.bindHover();
  }

  setActiveFromEvent(e) {
    const index = parseInt(e.currentTarget.dataset.index, 10);
    if (Number.isNaN(index)) return;
    this.setActive(index);
  }

  setActive(index) {
    this.links.forEach((el, i) => {
      const active = i === index;
      el.classList.toggle('is-active', active);
      if (active) el.setAttribute('aria-current', 'true');
      else el.removeAttribute('aria-current');
    });
    this.imageWrappers.forEach((el, i) => {
      const active = i === index;
      el.classList.toggle('is-active', active);
      el.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    this.ctas.forEach((el, i) => {
      const active = i === index;
      el.classList.toggle('is-active', active);
      if (active) {
        el.removeAttribute('tabindex');
        el.removeAttribute('aria-hidden');
      } else {
        el.setAttribute('tabindex', '-1');
        el.setAttribute('aria-hidden', 'true');
      }
    });
  }
}

if (!customElements.get('tk-gift-guide')) {
  customElements.define('tk-gift-guide', TkGiftGuide);
}
